import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, DollarSign, TrendingUp, Shield, Users, Calculator } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <DollarSign className="h-8 w-8 text-slate-600" />,
      title: "Financial Planning",
      description: "Comprehensive financial planning tailored to your unique goals and circumstances.",
      features: ["Retirement Planning", "Estate Planning", "Tax Strategies"]
    },
    {
      icon: <TrendingUp className="h-8 w-8 text-slate-600" />,
      title: "Investment Management",
      description: "Professional portfolio management with a focus on long-term growth and risk management.",
      features: ["Portfolio Analysis", "Asset Allocation", "Risk Assessment"]
    },
    {
      icon: <Shield className="h-8 w-8 text-slate-600" />,
      title: "Insurance Solutions",
      description: "Protect your family and assets with comprehensive insurance coverage options.",
      features: ["Life Insurance", "Disability Insurance", "Long-term Care"]
    },
    {
      icon: <Users className="h-8 w-8 text-slate-600" />,
      title: "Business Services",
      description: "Specialized financial services for business owners and entrepreneurs.",
      features: ["Business Planning", "Employee Benefits", "Succession Planning"]
    },
    {
      icon: <Calculator className="h-8 w-8 text-slate-600" />,
      title: "Tax Planning",
      description: "Strategic tax planning to minimize your tax burden and maximize savings.",
      features: ["Tax Optimization", "Deduction Strategies", "Year-end Planning"]
    }
  ];

  return (
    <section className="py-16 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Comprehensive financial solutions designed to help you achieve your goals and secure your future.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow duration-300 border-slate-200">
              <CardHeader>
                <div className="mb-4">{service.icon}</div>
                <CardTitle className="text-xl text-slate-800">{service.title}</CardTitle>
                <CardDescription className="text-slate-600">
                  {service.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-slate-700">
                      <CheckCircle className="h-4 w-4 text-slate-500 mr-2 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;